import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import Styles from '@widgets/shared/components/Notice/styles';
import { Title } from '@basket/components/GiftVoucherModal/styles';
import { useCallback, useState } from 'react';
import CurrencyInput from 'react-currency-input-field';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import API from '@widgets/shared/API/connection';
import FormNotices from '@widgets/shared/components/FormNotices';
import { useFormContext } from 'react-hook-form';
import { useAppDispatch } from '@basket/store/hooks';
const applyGiftVoucher = AwesomeDebouncePromise(API.applyGiftVoucher, 500);
function GiftVoucherModal(props) {
    const { onClose, giftCardBalance, giftCardExpires, maxValue, coupon, } = props;
    const min = 0.01;
    const max = Math.round(maxValue * 100) / 100; // fixing float rounding error
    const [customAmount, setCustomAmount] = useState(`${max}`);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [fieldError, setFieldError] = useState(null);
    const dispatch = useAppDispatch();
    const { setValue } = useFormContext();
    const stopProp = (ev) => {
        ev.stopImmediatePropagation();
    };
    const submitGiftVoucher = useCallback((e) => {
        // do stuff
        e.preventDefault();
        setIsSubmitting(true);
        applyGiftVoucher(coupon, customAmount).then((res) => {
            const { success } = res;
            if (!success) {
                const { errors, message: maybeMessage } = res;
                setFieldError(errors.find((error) => error.field === 'voucher-amount')?.message ?? null);
                setErrorMessage(maybeMessage ?? null);
                setIsSubmitting(false);
            }
            else {
                const basketResponse = res;
                window.dispatchEvent(new CustomEvent('basket.modify', {
                    detail: basketResponse,
                }));
                setIsSubmitting(false);
                onClose();
            }
        });
    }, [customAmount]);
    const handleCustomValueChanged = useCallback((newCustomValue) => {
        if (newCustomValue) {
            setErrorMessage(null);
            setFieldError(null);
            let parsedValue = parseFloat(`${newCustomValue}`);
            if (parsedValue < min) {
                parsedValue = min;
                setFieldError(`Must be £${min} or above`);
            }
            if (parsedValue > max) {
                parsedValue = max;
                setFieldError(`Must be £${max} or below`);
            }
            return setCustomAmount(`${parsedValue}`);
            // return setCustomAmount(newCustomValue);
        }
        return setCustomAmount('');
    }, [setCustomAmount]);
    return (_jsx(Styles.Backdrop, { onClick: onClose, children: _jsxs(Styles.Inner, { onClick: stopProp, children: [_jsx(Styles.Close, { className: "close", type: "button", onClick: onClose, title: "Close Modal", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--tooltip-close" }) }) }), _jsxs("div", { children: [_jsx(Title, { children: "Redeem Gift Voucher" }), _jsxs("form", { className: "form gift-vouchers", onSubmit: submitGiftVoucher, method: "POST", noValidate: true, children: [_jsxs("div", { className: "gift-vouchers__overview", children: [_jsx("span", { className: "h4 gift-vouchers__label", children: "Gift Voucher Balance" }), _jsxs("span", { className: "h2 gift-vouchers__total", children: ["\u00A3", giftCardBalance.toFixed(2)] }), _jsxs("span", { className: "p gift-vouchers__expires", children: [_jsx("span", { children: "Expires: " }), _jsx("time", { dateTime: giftCardExpires, children: giftCardExpires })] })] }), errorMessage && (_jsx("div", { style: { marginTop: '1.5rem' }, children: _jsx(FormNotices, { handleClose: () => setErrorMessage(null), message: errorMessage, type: "error" }) })), _jsxs("div", { className: `form__group ${fieldError ? 'form__group--error' : ''}`, children: [_jsx("label", { htmlFor: "voucher-amount", className: "form__label", children: "Enter a specific amount" }), _jsx(CurrencyInput, { type: "tel", id: "voucher-amount", allowNegativeValue: false, name: "amount", prefix: "\u00A3", min: min, max: max, className: "form__control", step: 1, onValueChange: handleCustomValueChanged, defaultValue: max, allowDecimals: true, decimalsLimit: 2, maxLength: 8, fixedDecimalLength: 2 }), fieldError && (_jsx("div", { className: "form__error", children: fieldError }))] }), _jsx("div", { className: "form__actions", children: _jsx("button", { className: "btn", type: "submit", disabled: isSubmitting || fieldError !== null, children: "Apply to Order" }) })] })] })] }) }));
}
export default GiftVoucherModal;
